import { RaidPlanAssignmentEntity } from 'app/frontend/types/custom/RaidPlan'
import {
  AssignmentScope,
  normalizeAssignmentBox,
  normalizeAssignmentCast,
} from './assignmentTimeline'
import getAssignmentEntityIdentity from './assignmentEntityIdentity'
import { RaidPlanEncounterAssignmentAbility } from 'app/frontend/types/custom/RaidPlan'

export const isRepeatableAssignmentEntity = (
  entity: RaidPlanAssignmentEntity,
) => entity.kind === 'by_role' || entity.kind === 'by_class'

export const getAssignmentUsageCountByIdentity = ({
  ability,
  scopes,
  assignmentGroups,
}: {
  ability: RaidPlanEncounterAssignmentAbility
  scopes: AssignmentScope[]
  assignmentGroups: number
}) =>
  scopes.reduce<Record<string, number>>((acc, scope) => {
    const scopeCountByIdentity = scope.castIndexes.reduce<
      Record<string, number>
    >((scopeAcc, castIndex) => {
      const cast = normalizeAssignmentCast(
        ability.casts[castIndex],
        assignmentGroups,
      )
      const castCountByIdentity = cast.boxes.reduce<Record<string, number>>(
        (castAcc, box) => {
          normalizeAssignmentBox(box).entities.forEach((entity) => {
            const identity = getAssignmentEntityIdentity(entity)
            castAcc[identity] = (castAcc[identity] ?? 0) + 1
          })
          return castAcc
        },
        {},
      )
      Object.entries(castCountByIdentity).forEach(([identity, count]) => {
        scopeAcc[identity] = Math.max(scopeAcc[identity] ?? 0, count)
      })
      return scopeAcc
    }, {})
    Object.entries(scopeCountByIdentity).forEach(([identity, count]) => {
      acc[identity] = (acc[identity] ?? 0) + count
    })
    return acc
  }, {})
